module.exports = __webpack_public_path__ + "37b1f8bf.svg";